import { useEffect } from 'react'
// @mui
import { Button, Stack, Typography } from '@mui/material'
// components
import Dialog from 'src/commons/components/Dialog'
// hooks
import { useUserKYC } from 'domains/Users/Verification/hooks/useVerificationUser'
import { useBoundVerificationUserStore } from 'domains/Users/Verification/stores'
// constants
import { MAIN_APP_URL } from 'constants/index'
import useLocales from 'hooks/useLocales'
import StateImage from 'components/state-image'

export default function VerificationConfirmation({
  open,
  openDialog,
  hasEmail,
}) {
  const { t } = useLocales()
  const { refetch: getUserKYC } = useUserKYC()
  const { setActiveStep } = useBoundVerificationUserStore(
    (state) => ({
      setActiveStep: state.setActiveStep,
    }),
  )

  useEffect(
    () => () => {
      if (open) {
        getUserKYC()
        setActiveStep(null)
      }
    },
    [open],
  )

  return (
    <Dialog
      open={open}
      header={<></>}
      body={
        <Stack
          sx={{
            padding: '14px',
          }}
          alignItems="center"
          spacing={2}
        >
          <StateImage
            illustrationName="illustration_upload"
            type="illustration"
          />
          <Stack
            direction="row"
            justifyContent="center"
            sx={{ marginBottom: '14px' }}
          >
            <Typography
              variant="h4"
              sx={(theme) => ({ color: theme.palette.grey[800] })}
            >
              {t('key_verification_is_processed')}
            </Typography>
          </Stack>
          {!hasEmail && (
            <Typography
              variant="body2"
              sx={(theme) => ({
                maxWidth: '420px',
                textAlign: 'center',
                color: theme.palette.grey[800],
              })}
            >
              {t(
                'key_want_to_stay_updated_regarding_your_verification_complete_your_email_by_clicking_the_complete_email_button_below',
              )}
            </Typography>
          )}
        </Stack>
      }
      footer={
        <Stack
          direction="row"
          spacing={2}
          sx={{
            padding: '0px 24px 24px 24px',
          }}
        >
          <Button
            id="b-users-verificationconfirmationdialog-close"
            variant="outlined"
            size="medium"
            fullWidth
            onClick={() => openDialog(false)}
          >
            {t('key_close')}
          </Button>
          {!hasEmail && (
            <Button
              id="b-users-verificationconfirmationdialog-open-account-settings"
              variant="contained"
              size="medium"
              fullWidth
              onClick={() => {
                window.open(
                  `${MAIN_APP_URL}/setting/account`,
                  '_blank',
                )
              }}
            >
              Lengkapi Email
            </Button>
          )}
        </Stack>
      }
      onClose={() => openDialog(false)}
    />
  )
}
